import * as React from 'react';
import classnames from 'classnames';
import { Flyout } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { getLocaleSwitcherData } from './utils/get-locale-switcher-data.js';
import { getLocaleSwitcherMenuLabel } from './utils/get-locale-switcher-menu-label.js';
import { getLocaleSwitcherMenuTitle } from './utils/get-locale-switcher-menu-title.js';

const createSubMenu = (items)=>{
    return items.map((item, index)=>{
        var ref, ref1;
         return React.createElement(Flyout.MenuItem, {
            key: item.label || index,
            link: item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.href,
            action: item === null || item === void 0 ? void 0 : (ref1 = item.parameters) === null || ref1 === void 0 ? void 0 : ref1.action
        }, item.label);
    });
};
const LocaleSwitcherMenu = ({ availableLocales , className  })=>{
    const intl = useIntl();
    const localeSwitcherData = getLocaleSwitcherData(availableLocales, true);
    const menuLabel = getLocaleSwitcherMenuLabel(intl.locale);
    const menuTitle = getLocaleSwitcherMenuTitle(availableLocales, intl.locale, menuLabel);
    return /*#__PURE__*/ React.createElement(Flyout, null, /*#__PURE__*/ React.createElement(Flyout.Trigger, {
        className: classnames('locale-switcher-menu__button--link header-menu__icon', className),
        title: menuTitle
    }, menuLabel), /*#__PURE__*/ React.createElement(Flyout.Menu, null, createSubMenu(localeSwitcherData)));
};

export { LocaleSwitcherMenu, LocaleSwitcherMenu as default };
//# sourceMappingURL=LocaleSwitcherMenu.js.map
